// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.8 16.62l-6.569-6.56a.322.322 0 00-.462 0l-6.57 6.56a1.286 1.286 0 01-1.825-1.81l7.263-7.252a1.943 1.943 0 012.726 0l7.263 7.252a1.283 1.283 0 01-.913 2.19 1.289 1.289 0 01-.912-.38z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;